import { render, staticRenderFns } from "./Addresale.vue?vue&type=template&id=66c7d63b"
import script from "./Addresale.vue?vue&type=script&lang=js"
export * from "./Addresale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports